module.exports = {
    // Заголовки/Текст заголовка
    login: 'Войти',
    allProductCategory: 'Все категории товаров',
    productRecommendation: 'Рекомендуемые товары',
    shopRecommendation: 'Рекомендуемые магазины',
    businessPhilosophy: 'Бизнес-философия',
    engine: 'Двигатель',
    transmission: 'Коробка передач',
    companyIntroduction: 'Введение компании',
    photoGallery: 'Галерея фотографий',
    contactWay: 'Контактная информация',
    basicInformation: 'Основная информация',
    specificationParameters: 'Параметры спецификации',
    productDescription: 'Описание товара',
    detailedInformation: 'Подробная информация',
    enterpriseName: 'Название предприятия',
    contact: 'Контактное лицо',
    email: 'Электронная почта',
    area: 'Область',
    detailedAddress: 'Подробный адрес',

    // Теги/Текст метки
    mainCategory: 'Основная категория',
    mainVehicleType: 'Основной тип автомобиля',
    mainBrand: 'Основной бренд',
    name: 'Название',
    unit: 'Единица',
    shopArea: 'Площадь магазина',
    shopLocation: 'Местоположение магазина',
    filterCondition: 'Условие фильтра',
    category: 'Категория',
    brand: 'Бренд',
    area_label: 'Область',
    productName: 'Название товара',
    drawingNumber: 'Номер рисунка',
    originBrand: 'Торговая марка происхождения',
    price: 'Цена',
    shopName: 'Название магазина',

    // Текст кнопки
    search: 'Поиск',
    register: 'Зарегистрироваться',
    mobilePhoneLogin: 'Вход по номеру мобильного телефона',
    accountLogin: 'Вход в аккаунт',
    getVerificationCode: 'Получить код подтверждения',
    registerAccount: 'Зарегистрироваться сейчас',
    forgotPassword: 'Забыли пароль?',
    contactMethod: 'Способ контакта',
    cancelCollection: 'Отменить сбор',
    collectShop: 'Собрать магазин',
    collected: 'Собрано',
    followShop: 'Следить за магазином',
    followed: 'Следят',
    addToCart: 'Добавить в корзину',
    contactMerchant: 'Связаться с продавцом',
    moreProducts: 'Больше товаров',
    moreShops: 'Больше магазинов',
    searchThisShop: 'Поиск в этом магазине',
    searchAllSites: 'Поиск на всех сайтах',
    confirm: 'Подтвердить',
    delete: 'Удалить',
    cancel: 'Отмена',
    allProducts: 'Все товары',
    companyInfo: 'Информация о компании',
    basicInfo: 'Основная информация',
    viewBrowsingHistory: 'История просмотра',
    productCollection: 'Коллекция товаров',
    followedShops: 'Магазины, на которые подписаны',
    settledStores: 'Поселившиеся магазины',
    feedback: 'Отзыв',
    officialService: 'Официальное обслуживание',
    goOfficialWebsite: 'Перейти на официальный веб-сайт',
    openShop: 'Открыть магазин',
    manageMyShop: 'Управлять моим магазином',
    registerAccount_btn: 'Зарегистрировать аккаунт',
    haveAccount: 'Уже есть учетная запись Вход',

    // Подсказки/Заполнители
    inputPhoneNumber: 'Пожалуйста, введите номер телефона',
    inputVerificationCode: 'Пожалуйста, введите код подтверждения',
    inputAccount: 'Пожалуйста, введите аккаунт',
    inputPassword: 'Пожалуйста, введите пароль',
    inputVerificationCodeAgain: 'Пожалуйста, введите код подтверждения',
    pleaseConfirmPassword: 'Пожалуйста, подтвердите пароль',
    inputRequiredItems: 'Пожалуйста, заполните обязательные поля',
    pleaseLogin: 'Пожалуйста, сначала войдите',
    notLoggedIn: 'Вы не вошли в систему',
    loggedIn: 'Вошли в систему',
    notOpenedMall: 'Магазин еще не открыт',
    haveOpenedMall: 'Вы открыли магазин',
    shopProductName: 'Название товара / Номер рисунка / Краткий код',
    searchQueryContent: 'Пожалуйста, введите содержание запроса',
    loginToGetPhone: 'Пожалуйста, войдите, чтобы получить',
    pleaseFillVerificationCode: 'Пожалуйста, заполните код подтверждения',
    loggingIn: 'Вход выполняется',
    loginSuccessRedirecting: 'Вход выполнен успешно, перенаправление',
    registerSuccessful: 'Регистрация успешна',
    collectSuccessful: 'Коллекция успешна',
    cancelSuccessful: 'Отмена успешна',
    addSuccessful: 'Добавление успешно',
    deleteSuccessful: 'Удаление успешно',
    removeFromCart: 'Удалить этот товар из корзины?',
    cancelDelete: 'Удаление отменено',
    hint: 'Подсказка',
    businessConcept: 'Расширьте возможности заводов, выигрыш для всех сторон<br />Рука об руку, строим будущее вместе',
    companyDescription: 'Основной бизнес: двигатели и детали Sinotruk и Weichai, двигатели и детали строительной техники, представительство крупных международных брендов: немецкой Hangsdt, немецкой Mahle, немецкой Manhummel, американской Donaldson, отечественные бренды сотрудничества: Zhongyuan, Blibo, Jiangbin, Bohai, Weifu',
    transmissionDescription: 'Применимые модели: серия тяжелых грузовиков, полный спектр трансмиссий серии горных грузовиков<br/>Профессиональное производство трансмиссий двигателей Sinotruk<br/>Оригинальное совпадение трансмиссии, совершенно новая сборка',
    pleaseLoginAfterGetContact: 'Пожалуйста, войдите для просмотра',
    quote: '—— Honda',
    welcomeUse: 'Добро пожаловать',
    shopMallName: 'Торговый центр интеллектуальных автозапчастей Xingzhe',
    shopMallIntro: 'Войдите в Xingzhe Intelligence и откройте новую эру обращения автозапчастей вместе с коллегами в индустрии автозапчастей!',
    businessPhilosophyText: 'Расширьте возможности заводов, выигрыш для всех сторон<br />Рука об руку, строим будущее вместе',
    account: 'Аккаунт',
    password: 'Пароль',
    phone: 'Номер телефона',
    verificationCode: 'Код подтверждения',
    home: 'Главная',
    officialWebsite: 'Официальный сайт',
    manageSystemExperience: 'Демонстрация системы управления',
    loginPrompt: 'Пожалуйста, войдите',
    clickToLogout: 'Нажмите, чтобы выйти',
    myOrders: 'Мои заказы',
    websiteService: 'Службы сайта',
    contactCustomerService: 'Связаться с поддержкой',
    shoppingCartLabel: 'Корзина',
    confirmLogoutMessage: 'Вы хотите выйти из системы? (Некоторые функции станут недоступны)',
    logoutSuccess: 'Выход выполнен',
    logoutCancelled: 'Отменено',
    productSearch: 'Поиск товара',
    shopSearch: 'Поиск магазина',
    footerCopyright: 'Copyright © 2024 XingZheZhiNeng All Rights Reserved.',
    addWeChatConsultation: 'Добавить WeChat-консультацию',
    saveImage: 'Сохранить изображение',
    productsZone: 'Раздел товаров',
    shopsZone: 'Раздел магазинов',
    newArrivals: 'Новинки',
    clearanceDeals: 'Распродажа',
    hotProducts: 'Хиты продаж',
    drawingNameSearch: 'Поиск по номеру/названию',
    languageChanged: 'Язык изменен'
}